import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_COMMERCE_LINKS_LIST,
  FETCH_COMMERCE_LINKS_LIST_ERROR,
  CLEAR_FETCH_COMMERCE_LINKS_LIST,
  APPLY_COMMERCE_LINK_DRAG,
  APPLY_COMMERCE_LINK_DRAG_ERROR,
  CLEAR_COMMERCE_LINK_DRAG,
  ADD_COMMERCE_LINK_SUCCESS,
  ADD_COMMERCE_LINK_ERROR,
  CLEAR_ADD_COMMERCE_LINK,
  PATCH_COMMERCE_LINK_SUCCESS,
  PATCH_COMMERCE_LINK_ERROR,
  CLEAR_PATCH_COMMERCE_LINK,
  DELETE_COMMERCE_LINK_SUCCESS,
  DELETE_COMMERCE_LINK_ERROR,
  CLEAR_DELETE_COMMERCE_LINK,
  ADD_COMMERCE_AMOUNT_SUCCESS,
  ADD_COMMERCE_AMOUNT_ERROR,
  CLEAR_ADD_COMMERCE_AMOUNT,
  PATCH_COMMERCE_AMOUNT_SUCCESS,
  PATCH_COMMERCE_AMOUNT_ERROR,
  CLEAR_PATCH_COMMERCE_AMOUNT,
  DELETE_COMMERCE_AMOUNT_SUCCESS,
  DELETE_COMMERCE_AMOUNT_ERROR,
  CLEAR_DELETE_COMMERCE_AMOUNT,
  CREATE_STRIPE_ACCOUNT_SUCCESS,
  CREATE_STRIPE_ACCOUNT_ERROR,
  CLEAR_CREATE_STRIPE_ACCOUNT,
  CONNECT_STRIPE_ACCOUNT_SUCCESS,
  CONNECT_STRIPE_ACCOUNT_ERROR,
  CLEAR_CONNECT_STRIPE_ACCOUNT,
} from 'redux/commerce/types';


export const fetchCommerceLinksList = () => baseErrorsHandlerDecorator(
  FETCH_COMMERCE_LINKS_LIST,
  FETCH_COMMERCE_LINKS_LIST_ERROR,
  () => restapi.get(addLang('commerce/')),
  false,
);

export const clearFetchCommerceLinksList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_COMMERCE_LINKS_LIST,
  });
};

export const applyCommerceLinkDrag = formData => baseErrorsHandlerDecorator(
  APPLY_COMMERCE_LINK_DRAG,
  APPLY_COMMERCE_LINK_DRAG_ERROR,
  () => restapi.post(addLang('commerce/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearCommerceLinkDrag = () => dispatch => {
  dispatch({
    type: CLEAR_COMMERCE_LINK_DRAG,
  });
};

export const addCommerceLink = linkType => baseErrorsHandlerDecorator(
  ADD_COMMERCE_LINK_SUCCESS,
  ADD_COMMERCE_LINK_ERROR,
  () => restapi.post(addLang('commerce/create/'), { link_type: linkType }),
  false,
  true /* actionSucces */,
);

export const clearAddCommerceLink = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_COMMERCE_LINK,
  });
};

export const patchCommerceLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_COMMERCE_LINK_SUCCESS,
  PATCH_COMMERCE_LINK_ERROR,
  () => restapi.patch(addLang(`commerce/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchCommerceLink = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_COMMERCE_LINK,
  });
};

export const deleteCommerceLink = linkId => baseErrorsHandlerDecorator(
  DELETE_COMMERCE_LINK_SUCCESS,
  DELETE_COMMERCE_LINK_ERROR,
  () => restapi.delete(addLang(`commerce/${linkId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteCommerceLink = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_COMMERCE_LINK,
  });
};

export const addCommerceAmount = formData => baseErrorsHandlerDecorator(
  ADD_COMMERCE_AMOUNT_SUCCESS,
  ADD_COMMERCE_AMOUNT_ERROR,
  () => restapi.post(addLang('commerce/amount-variant/'), formData),
  false,
  true /* actionSucces */,
);

export const clearAddCommerceAmount = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_COMMERCE_AMOUNT,
  });
};

export const deleteCommerceAmount = amountId => baseErrorsHandlerDecorator(
  DELETE_COMMERCE_AMOUNT_SUCCESS,
  DELETE_COMMERCE_AMOUNT_ERROR,
  () => restapi.delete(addLang(`commerce/amount-variant/${amountId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteCommerceAmount = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_COMMERCE_AMOUNT,
  });
};

export const patchCommerceAmount = (amountId, formData) => baseErrorsHandlerDecorator(
  PATCH_COMMERCE_AMOUNT_SUCCESS,
  PATCH_COMMERCE_AMOUNT_ERROR,
  () => restapi.patch(addLang(`commerce/amount-variant/${amountId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchCommerceAmount = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_COMMERCE_AMOUNT,
  });
};

export const createStripeAccount = formData => baseErrorsHandlerDecorator(
  CREATE_STRIPE_ACCOUNT_SUCCESS,
  CREATE_STRIPE_ACCOUNT_ERROR,
  () => restapi.post(addLang('commerce/stripe/create-account/'), formData),
);

export const clearCreateStripeAccount = () => dispatch => {
  dispatch({
    type: CLEAR_CREATE_STRIPE_ACCOUNT,
  });
};

export const connectStripeAccount = formData => baseErrorsHandlerDecorator(
  CONNECT_STRIPE_ACCOUNT_SUCCESS,
  CONNECT_STRIPE_ACCOUNT_ERROR,
  () => restapi.post(addLang('commerce/stripe/connect-account/'), formData),
);

export const clearConnectStripeAccount = () => dispatch => {
  dispatch({
    type: CLEAR_CONNECT_STRIPE_ACCOUNT,
  });
};
